module.exports = __webpack_public_path__ + "static/media/clients.ca1ebe75.png";